import { supabase } from '../../adapters/database/supabaseClient'
import type { CashCartLine, CreatedOrder, RecentOrder } from './types'

export async function createCashOrder(eventId: string, lines: CashCartLine[]): Promise<CreatedOrder> {
  const payload = lines.map(line => ({ productId: line.productId, quantity: line.quantity, variantIds: line.variantIds,...(line.note?{note:line.note}:{}) }))
  const { data, error } = await supabase.rpc('create_cash_order', { target_event_id: eventId, target_items: payload })
  if (error) throw error
  const row = Array.isArray(data) ? data[0] : data
  if (!row) throw new Error('Ordine non creato')
  return { id: row.order_id, number: Number(row.order_number), totalCents: row.total_cents }
}

export async function listRecentOrders(eventId: string, limit = 8): Promise<RecentOrder[]> {
  const { data, error } = await supabase.from('orders').select('id,event_id,number,status,total_cents,created_at').eq('event_id', eventId).order('created_at', { ascending: false }).limit(limit)
  if (error) throw error
  return (data ?? []).map(row => ({ id: row.id,eventId: row.event_id,number:Number(row.number),status:row.status,totalCents:row.total_cents,createdAt:row.created_at }))
}
